import { el, setAttr, mount, unmount, setChildren } from 'redom';

import { stringToSVG } from '../../../../utilities';

import { isAudioMime, isVideoMime, isImageMime } from '../../../utilities';

import AttachmentViewer from './viewer';

import downloadAttachmentIcon from '../../../../assets/images/svg/download-attachment-icon';
import pdfFileIcon from '../../../../assets/images/svg/pdf-file-icon';
import textFileIcon from '../../../../assets/images/svg/text-file-icon';
import wordFileIcon from '../../../../assets/images/svg/word-file-icon';
import csvFileIcon from '../../../../assets/images/svg/csv-file-icon';
import spreadsheetFileIcon from '../../../../assets/images/svg/spreadsheet-file-icon';
import codeFileIcon from '../../../../assets/images/svg/code-file-icon';
import archiveFileIcon from '../../../../assets/images/svg/archive-file-icon';
import unknownFileIcon from '../../../../assets/images/svg/unknown-file-icon';

// const downloadAttachmentIcon = stringToSVG(downloadAttachmentIconString);
// const textFileIcon = stringToSVG(textFileIconString);
// const csvFileIcon = stringToSVG(csvFileIconString);
// const wordFileIcon = stringToSVG(wordFileIconString);
// const pdfFileIcon = stringToSVG(pdfFileIconString);
// const unknownFileIcon = stringToSVG(unknownFileIconString);

textFileIcon.classList.add('text-file-icon');
csvFileIcon.classList.add('csv-file-icon');
wordFileIcon.classList.add('word-file-icon');
pdfFileIcon.classList.add('pdf-file-icon');
spreadsheetFileIcon.classList.add('spreadsheet-file-icon');
codeFileIcon.classList.add('code-file-icon');
archiveFileIcon.classList.add('archive-file-icon');
unknownFileIcon.classList.add('unknown-file-icon');

const spreadsheetMimetypes = [
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.oasis.opendocument.spreadsheet'
];

const codeMimetypes = [
  'text/html',
  'text/css',
  'text/javascript',
  'application/javascript',
  'application/json',
  'text/xml',
  'application/xml'
];

const archiveMimetypes = [
  'application/zip',
  'application/x-zip-compressed',
  'application/x-rar-compressed',
  'application/vnd.rar',
  'application/x-7z-compressed',
  'application/x-tar',
  'application/gzip'
];

class MessageAttachment {

  constructor() {

    this.attachment = null;
    this.attachmentViewer = null;

    this.downloadButton = el('button.attachment-download-button', {
      onclick: this.handleDownloadButtonClick.bind(this)
    }, [
      downloadAttachmentIcon.cloneNode(true)
    ]);

    this.el = el('li.inbox-message-group-message-attachment', {
      onclick: this.handleAttachmentClick.bind(this)
    }, [
      this.downloadButton
    ]);

  }

  handleDownloadButtonClick(event) {

    event.stopPropagation();

    var url = this.attachment.url; // Use the direct URL of the file
    var filename = this.attachment.name; // Specify the filename you want to download as

    // Create an anchor element and use the direct file URL
    var anchor = document.createElement('a');
    anchor.style.display = 'none';
    anchor.href = url;
    anchor.target = '_blank';
    anchor.download = filename; // Specify the filename for the download
    document.body.appendChild(anchor);
    anchor.click();

    // Clean up by removing the anchor after initiating the download
    setTimeout(function() {
      document.body.removeChild(anchor);
    }, 100);

    return false;

  }

  handleAttachmentViewerClose() {
    unmount(this.el, this.attachmentViewer);
  }

  handleAttachmentClick(event) {

    const attachment = this.attachment;

    if (isVideoMime(attachment.mimetype) === true || isImageMime(attachment.mimetype) === true) {
      this.attachmentViewer = new AttachmentViewer({ attachment, onClose: this.handleAttachmentViewerClose.bind(this) });
      mount(this.el, this.attachmentViewer);
      return;
    }

    if (attachment.mimetype === 'application/venturz-page-template') {
      // eslint-disable-next-line no-undef
      SelfDestructingMessage.info('Output is being generated, please wait for a few minutes!');
      return;
    }

    this.handleDownloadButtonClick(event);

  }

  displayImage(attachment) {

    setChildren(this.el, [this.downloadButton, el('img', {
      src: attachment.url
    })]);

  }

  displayVideo(attachment) {

    setChildren(this.el, [this.downloadButton, el('video', {
      src: attachment.url,
      preload: 'metadata'
    })]);

  }

  displayAudio(attachment) {

    setChildren(this.el, [this.downloadButton, el('audio', {
      src: attachment.url,
      preload: 'metadata'
    })]);

  }

  displayUnknownAttachmentTypeMessage(attachment) {

    const mimetype = attachment.mimetype;
    let icon = unknownFileIcon.cloneNode(true);

    if (mimetype === 'application/pdf') {
      icon = pdfFileIcon.cloneNode(true);
    }

    if (mimetype === 'text/csv') {
      icon = csvFileIcon.cloneNode(true);
    }

    if (mimetype === 'text/plain') {
      icon = textFileIcon.cloneNode(true);
    }

    if (spreadsheetMimetypes.indexOf(mimetype) !== -1) {
      icon = spreadsheetFileIcon.cloneNode(true);
    }

    if (codeMimetypes.indexOf(mimetype) !== -1) {
      icon = codeFileIcon.cloneNode(true);
    }

    if (archiveMimetypes.indexOf(mimetype) !== -1) {
      icon = archiveFileIcon.cloneNode(true);
    }

    const wordFileTypes = [
      'application/msword',
      'application/vnd.openxmlformats',
      'officedocument.wordprocessingml.document',
      'application/venturz-page-template'
    ];

    if (wordFileTypes.indexOf(mimetype) !== -1) {
      icon = wordFileIcon.cloneNode(true);
    }

    this.icon = icon;

    let children = [this.downloadButton, this.icon];

    if (mimetype === 'application/venturz-page-template') {
      children = [this.icon];
    }

    setChildren(this.el, children);

  }

  update(attachment) {

    this.attachment = attachment;

    if (isAudioMime(attachment.mimetype) === true) {
      this.displayAudio(attachment);
    } else if (isVideoMime(attachment.mimetype) === true) {
      this.displayVideo(attachment);
    } else if (isImageMime(attachment.mimetype) === true) {
      this.displayImage(attachment);
    } else {
      this.displayUnknownAttachmentTypeMessage(attachment);
    }

    setAttr(this.el, {
      title: attachment.name
    });

  }

}

export default MessageAttachment;